import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min';
import 'typeahead.js/dist/typeahead.bundle.min';
import 'bootstrap-duallistbox/dist/jquery.bootstrap-duallistbox.min';
import 'croppie/croppie.min';
import 'jquery-form/jquery.form';
import 'jquery-mask-plugin';
import 'holderjs/holder.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import 'bootstrap-duallistbox/dist/bootstrap-duallistbox.min.css';
import 'croppie/croppie.css';

import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/dialog.css';
import 'jquery-ui/themes/base/draggable.css';
import 'jquery-ui/themes/base/resizable.css';
import 'jquery-ui/themes/base/tooltip.css';
import 'jquery-ui/themes/base/theme.css';

import '../css/typeahead.js-bootstrap3.css';
import '../css/custom.css';
import '../../tinymce/tinymce_setup_cabinet';
import './utils';


import {EditorPanel, EditorPanelForm} from './components/editor_panel';
import {Material, MaterialForm, editMaterial, showMaterialHistory} from './components/material';
import {Person, showPersonHistory, show_record} from './components/person.js';
import {Reference, ReferenceForm} from './components/reference';
import {RelationLink, RelationLinksListForm} from './components/relation_links';
import {SearchSynonyms, SearchSynonymsListForm} from './components/search_synonyms';
import $ from 'jquery';
import Bloodhound from 'typeahead.js/dist/bloodhound.min';
import {Profile} from './components/profile';
import {Records} from './components/records';
import {Task} from './components/task';
import ko from 'knockout';

import 'select2';
import 'select2/dist/css/select2.css'; 

// Объявляем глобальные переменные, которые используются в шаблонах и неимпортированных js-файлах

window.ko = ko;

window.RelationLinksListForm = RelationLinksListForm;
window.RelationLink = RelationLink;

window.ReferenceForm = ReferenceForm;

window.showPersonHistory = showPersonHistory;
window.showMaterialHistory = showMaterialHistory;

window.MaterialForm = MaterialForm;
window.editMaterial = editMaterial;

window.SearchSynonymsListForm = SearchSynonymsListForm;
window.SearchSynonyms = SearchSynonyms;

window.EditorPanelForm = EditorPanelForm;

window.show_record = show_record;

var cropperCutSuccess = true; // Global flag variable
console.log('cropperCutSuccess', cropperCutSuccess)
var FORMSETS = {};
window.FORMSETS = FORMSETS;
var listbox_common = {
    //nonSelectedListLabel: 'Не выбрано',
    //selectedListLabel: 'Выбрано',
    preserveSelectionOnMove: 'перемещено',
    moveOnSelect: false,
    infoText: 'Отображаются все {0}',
    filterPlaceHolder: 'Фильтр',
    filterTextClear: 'показать все',
    moveSelectedLabel: 'Перенести выбранное',
    moveAllLabel: 'Перенести всё',
    removeSelectedLabel: 'Убрать выбранное',
    removeAllLabel: 'Убрать всё',
    infoTextFiltered: '<span class="label label-warning">Отфильтровано</span> {0} из {1}',
    infoTextEmpty: 'Пустой список',
};
window.listbox_common = listbox_common;

var $lib = {};
window.$lib = $lib;

$(function() {
    var readyDfr = $.Deferred();
    var allReadyDfrs = [];
    var cnt = 0;

    $(function() {
        setTimeout(function() {
            if (cnt === 0) {
                readyDfr.resolve();
            }
        }, 100);
    });

    $lib.addReadyByTinyMCE = function(settings) {
        var sel = $(settings['selector']);
        if (sel.is(':visible')) {
            var oldSetup = settings.setup || function() {};
            var dfr = $.Deferred();
            settings.setup = function(ed) {
                oldSetup.apply(this, arguments);
                ed.on('init', function(ed) {
                    dfr.resolve();
                });
            };
            $lib.addReadyByDfr(dfr);
        }
    };

    $lib.addReadyByDfr = function(dfr) {
        allReadyDfrs.push(dfr);
        cnt++;
        dfr.done(function() {
            cnt--;
            if (cnt === 0) {
                allReadyDfrs = [];

                if (readyDfr.state() === 'pending') {
                    readyDfr.resolve();
                }
            }
        });
    };

    $lib.getAllReadyDfr = function() {
        return readyDfr;
    };
});

var datePickers = [];

var init_datepickers = function() {
    $.each($('.u-datepicker-inside'), function(index) {
        var newDate = {
            dayCalendar: null,
            monthCalendar: null,
            yearCalendar: null,
            day: '',
            month: '',
            year: '',
        };
        datePickers.push(newDate);

        var index = index;
        // datePickers.push(new DatePicker);
        var $wrapper = $(this);

        var $day = $($wrapper.find('.u-datepicker-day input'));
        var $month = $($wrapper.find('.u-datepicker-month input'));
        var $year = $($wrapper.find('.u-datepicker-year input'));

        datePickers[index].day = +$day.val() || 1;
        datePickers[index].month = +$month.val() || 1;
        datePickers[index].year = +$year.val() || 1900;

        function monthInputHandler(index) {
            if ($(this).val() !== '') {
                var validValue = Math.max(Math.min(12, $(this).val()), 1);
                $(this).val(validValue);
            }
        }

        function monthInputChangeHandler(index) {
            var year = datePickers[index].year || '1980';
            datePickers[index].month = +$(this).val() - 1;

            datePickers[index].dayCalendar.datepicker('destroy');
            datePickers[index].dayCalendar.datepicker({
                useCurrent: false,
                format: 'dd',
                minViewMode: 0,
                autoclose: true,
                defaultViewDate: {
                    year: year,
                    month: datePickers[index].month,
                    day: 5,
                }, //month: [0-11]
                language: 'ru',
                updateViewDate: false,
            });
        }

        $month.on('input', function() {
            monthInputHandler.call(this, index);
        });

        $month.on('change', function() {
            monthInputChangeHandler.call(this, index);
        });

        $($day).on('input focus', function(e) {
            var _this = this;

            setTimeout(function() {
                var inputVal = $(_this).val();
                var daysArray = $('.datepicker-days').find('td.day');
                $.each(daysArray, function(index, i) {
                    var $i = $(i);
                    if (!$i.hasClass('new') && !$i.hasClass('old') && $i.html() === inputVal) {
                        $i.addClass('active');
                    }
                });
            }, 200);
        });

        const datePickerContainer = '#person-separated-datepicker';

        datePickers[index].dayCalendar = $day
            .datepicker({
                format: 'dd',
                minViewMode: 0,
                autoclose: true,
                language: 'ru',
                container: datePickerContainer,
                defaultViewDate: {
                    year: datePickers[index].year,
                    month: datePickers[index].month - 1,
                    day: 5,
                }, //month: [0-11]
                updateViewDate: false,
            })
            .on('changeDate', function(e) {
                datePickers[index].day = e.date.getDate();
            })
            .on('show', function(e) {});

        datePickers[index].monthCalendar = $month
            .datepicker({
                format: 'mm',
                minViewMode: 1,
                autoclose: true,
                container: datePickerContainer,
                defaultViewDate: {
                    year: datePickers[index].year,
                    month: datePickers[index].month - 1,
                    day: 5,
                },
                language: 'ru',
            })
            .on('changeDate', function(e, $day) {
                var year = datePickers[index].year || '1980';
                datePickers[index].month = +e.date.getMonth();

                datePickers[index].dayCalendar.datepicker('destroy');
                datePickers[index].dayCalendar.datepicker({
                    useCurrent: false,
                    format: 'dd',
                    minViewMode: 0,
                    autoclose: true,
                    container: datePickerContainer,
                    defaultViewDate: {
                        year: year,
                        month: datePickers[index].month,
                        day: 5,
                    }, //month: [0-11]
                    language: 'ru',
                    updateViewDate: false,
                });
            })
            .on('changeDate', function() {});

        datePickers[index].yearCalendar = $year
            .datepicker({
                format: 'yyyy',
                defaultViewDate: {year: 1890, month: 0, day: 5},
                viewMode: 'years',
                minViewMode: 'years',
            })
            .on('changeDate', function(e, $day) {
                datePickers[index].year = e.date.getFullYear();

                datePickers[index].dayCalendar.datepicker('destroy');
                datePickers[index].dayCalendar.datepicker({
                    useCurrent: false,
                    format: 'dd',
                    minViewMode: 0,
                    autoclose: true,
                    container: datePickerContainer,
                    defaultViewDate: {
                        year: datePickers[index].year,
                        month: datePickers[index].month,
                        day: 5,
                    }, //month: [0-11]
                    language: 'ru',
                    updateViewDate: false,
                });

                datePickers[index].monthCalendar.datepicker('destroy');
                datePickers[index].monthCalendar.datepicker({
                    format: 'mm',
                    minViewMode: 1,
                    autoclose: true,
                    container: datePickerContainer,
                    defaultViewDate: {
                        year: datePickers[index].year,
                        month: datePickers[index].month,
                        day: 5,
                    },
                    language: 'ru',
                });
            });
    });
};

var typeheadInput = null,
    typeheadInputValue = null; //[1]

/**
 *
 * @param key
 * @param primary
 * @param field_id
 * @param update_id_field_id
 * @param notFound? => принимает true/false, показывать/не показывать not found template[2]
 * @param addMoreBtn? =>  принимает true/false, показывать/не показывать кнопку
 * @constructor
 */

function Init_typeahead(key, primary, field_id, update_id_field_id, notFound, addMoreBtn) {
    //notFound(not required) принимает true/false, показывать/не показывать not found template[2]
    var self = this;

    self.postDestination = key; // класс для родительского элемента в dom

    var url = '/cabinet/ajax/autocomplete/' + key + '/?query=%QUERY';
    if (primary != 'undefined') url += '&is_primary=' + primary;

    var dataset = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: url,
            wildcard: '%QUERY',
        },
    });

    dataset.initialize();

    $('#' + field_id)
        .typeahead(null, {
            displayKey: 'name',
            limit: 150,
            source: dataset.ttAdapter(),
            templates: {
                notFound:
                    notFound && addMoreBtn
                        ? '<p style="margin: 5px 10px">Совпадений не найдено<br><a class="btnAddNewTag" href="#">Добавить новую позицию</a></p>'
                        : notFound
                        ? '<p style="margin: 5px 10px">Совпадений не найдено</p>'
                        : '', //[2]
            },
        })
        .bind('typeahead:select', function(ev, suggestion) {
            $('#' + update_id_field_id).val(suggestion['id']);
        });

    $('.' + self.postDestination)
        .unbind()
        .on(
            'click',
            '.btnAddNewTag',
            function(e) {
                e.preventDefault();
                // typeheadInput = $('.' + self.postDestination).find('.form-control.tt-input');
                typeheadInput = $(e.target)
                    .closest('.tt-menu')
                    .siblings('.tt-input');
                typeheadInputValue = typeheadInput.val();
                var that = e.target;

                $(
                    "<div><br><input  style='width: 512px' class='' placeholder='Введите позицию' type='text'><br></div>"
                ).dialog({
                    dialogClass: 'no-close',
                    title: 'Добавить новую позицию',
                    modal: true,
                    minWidth: 590,
                    closeText: null,
                    open: function(event, ui) {
                        $(this)
                            .find('input')
                            .val(typeheadInputValue);
                    },
                    buttons: [
                        {
                            text: 'Добавить',
                            click: function() {
                                var inputValue = $(this)
                                    .find('input')
                                    .val();
                                $(typeheadInput).val(inputValue);
                                $('.u-save-person').trigger('click');
                            },
                        },
                        {
                            text: 'Закрыть',
                            click: function() {
                                $(this).dialog('close');
                                typeheadInput = null;
                                typeheadInputValue = null;
                            },
                        },
                    ],
                });
            }.bind(this)
        );
}

window.Init_typeahead = Init_typeahead;

var init_formsets = function() {
    $.each($('.u-formset'), function(index) {
        console.log('init_formsets');

        var $formset = $(this);
        var formset_name = $formset.data('formset-key');

        FORMSETS[formset_name]['body'] = $formset.find('.u-formset-template');

        $formset.find('.u-formset-template').remove();

        $formset.find('.u-add-more').click(function(e) {
            var formset_name = $(this).data('formset-key');

            var $total_forms = parseInt($('#id_' + formset_name + '-TOTAL_FORMS').val(), 10);
            $('#id_' + formset_name + '-TOTAL_FORMS').val($total_forms + 1);

            var $append_to = $(this)
                .parents('.u-formset')
                .find('.u-append-form-here');

            if (!$append_to.length) {
                $append_to = $(this)
                    .parent()
                    .parent();
            }

            $.each($(FORMSETS[formset_name]['body']).children(), function() {
                var current_html = $(this)[0].outerHTML.replace(
                    new RegExp(formset_name + '-__prefix__-', 'g'),
                    formset_name + '-' + $total_forms + '-'
                );

                current_html = current_html.replace(
                    new RegExp(
                        '"' + formset_name + '-' + $total_forms + '-position" value="-1"',
                        'g'
                    ),
                    '"' +
                        formset_name +
                        '-' +
                        $total_forms +
                        '-position" value="' +
                        $total_forms +
                        '"'
                );

                $append_to.before(current_html);
            });

            // var timer = null;
            // timer = setTimeout(function() {
            //     jQuery('html, body').stop().animate({
            //         scrollTop: $append_to.offset().top
            //     }, 200);
            // }, 200);

            init_datepickers();

            e.preventDefault();
        });
    });
};

window.init_formsets = init_formsets;

//init WYSIWYG
var wysiwygInit = function(id, height) {
    var settings = jQuery.extend({}, tinyMCE_base_settings);
    settings['selector'] = id;
    settings['height'] = height;
    settings['video_template_callback'] = function(data) {
        return (
            '<video width="' +
            data.width +
            '" height="' +
            'auto' +
            '"' +
            '' +
            (data.poster ? ' poster="' + data.poster + '"' : '') +
            ' controls="controls">\n' +
            '' +
            '<source src="' +
            data.source1 +
            '"' +
            (data.source1mime ? ' type="' + '' + data.source1mime + '"' : '') +
            ' />\n' +
            (data.source2
                ? '<source src="' +
                  '' +
                  data.source2 +
                  '"' +
                  (data.source2mime ? ' type="' + data.source2mime + '"' : '') +
                  ' />\n'
                : '') +
            '</video>'
        );
    };

    $lib.addReadyByTinyMCE(settings);
    tinyMCE.init(settings);
};

window.wysiwygInit = wysiwygInit;

//imageUploader
var imageUploader = function(
    uploadButton,
    deleteButton,
    fileUploader,
    imageBlock,
    uploadField,
    uploadLabel
) {
    //setLabelWidth
    setTimeout(function() {
        $(uploadLabel).css({
            width: $(imageBlock).width(),
            height: $(imageBlock).height(),
        });
    });

    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            var fileType = input.files[0]['type'];

            if (fileType !== 'image/png' && fileType !== 'image/jpeg' && fileType !== 'image/jpg') {
                var warningMessage =
                    '<p>' +
                    'Данный формат изображения не поддерживается системой.' +
                    'Присоедините изображение в формате <strong>jpeg(jpg)</strong> или <strong>png</strong>' +
                    '</p>';

                $(warningMessage).dialog({
                    dialogClass: 'no-close',
                    modal: true,
                    closeText: null,
                    buttons: [
                        {
                            text: 'Вернуться к редактированию',
                            click: function() {
                                $(this).dialog('close');
                                $(uploadLabel).show();
                                $(imageBlock).hide();
                                $(uploadField).val('');
                                $(fileUploader).val('');
                                $(imageBlock).attr('src', '');
                            },
                        },
                    ],
                });
            } else {
                reader.onload = function(e) {
                    cropperCutSuccess = false;
                    var targetSource = e.target.result;

                    $(imageBlock).attr('src', targetSource);
                    $(uploadField).val(targetSource);

                    getImgSize(targetSource);

                    function getImgSize(imgSrc) {
                        var newImg = new Image();

                        newImg.onload = function() {
                            var height = newImg.height;
                            var width = newImg.width;

                            resizeBigImage(width, height, targetSource);
                        };

                        newImg.src = imgSrc;
                    }

                    function resizeBigImage(width, height, imagesource) {
                        var canvas = document.createElement('canvas');
                        var img = document.createElement('img');
                        var MAX_HEIGHT = 300,
                            MAX_WIDTH = 300;

                        img.onload = function () {
                            if (height > width) {
                                if (width > MAX_WIDTH) {
                                    height *= MAX_WIDTH / width;
                                    width = MAX_WIDTH;
                                }
                            } else {
                                if (height > MAX_HEIGHT) {
                                    width *= MAX_HEIGHT / height;
                                    height = MAX_HEIGHT;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            var ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0, width, height);
                            var dataurl = canvas.toDataURL(fileType || 'image/png');
                            $(imageBlock).attr('src', dataurl);
                            $(uploadField).val(dataurl);
                        }
                        img.src = imagesource;
                    }
                };
                reader.readAsDataURL(input.files[0]);
            }
        }
    };

    $(fileUploader).on('change', function() {
        readURL(this);
        $(this)
            .closest('form')
            .find(uploadLabel)
            .hide();
        $(imageBlock).show();
    });

    $(uploadButton).on('click', function() {
        $(fileUploader).click();
    });

    $(deleteButton).on('click', function() {
        cropperCutSuccess = true;
        var control = $(fileUploader);

        $(imageBlock).attr('src', '');
        $(uploadField).val('delete-image');
        $(imageBlock).hide();
        $(this)
            .closest('form')
            .find(uploadLabel)
            .show();

        control.replaceWith(control.val('').clone(true));
    });

    $(uploadLabel).on('click', function() {
        $(fileUploader).click();
    });

    /**
     * @title-start imagecropper
     * @desc встраивает редактор для изображений
     * @author rasul.sahibjanli@gmail.com
     */
    imageCropper();

    function imageCropper() {
        var imageToCrop, imageToCropSrc, imageToCropType;

        if (!$('.crop-me').hasClass('crop-me-inited')) {
            $(
                '<br><button type="button" class="btn btn-default btn_m_top btn-sm crope-start">Обрезать</button>'
            ).insertAfter('.crop-me');
            $('.crop-me').addClass('crop-me-inited');
        }

        $('.crope-start')
            .off()
            .on('click', initCropping);

        function initCropping(e) {
            e.stopPropagation();
            e.preventDefault();

            imageToCrop = $(this).siblings('img');
            imageToCropSrc = imageToCrop.attr('src');

            if (imageToCropSrc.match(/\.(jpeg|jpg)$/) != null) {
                imageToCropType = 'jpeg';
            } else {
                imageToCropType = 'png';
            }

            if (!imageToCropSrc) {
                alert('Изображение отсутсвует, загрузите изображение и попробуйте снова');
            } else {
                var imageWidth = imageToCrop.width(),
                    imageHeight = imageToCrop.height(),
                    croperWidth = Math.max(imageWidth + 50, 900),
                    croperHeight = Math.max(imageHeight + 50, 600),
                    viewPortWidth = imageToCrop.data('width') || imageWidth,
                    viewPortHeight = imageToCrop.data('height') || imageHeight;

                $('body').append(
                    ' <div class="cropper__modal-window">' +
                        '<span class="glyphicon glyphicon-remove cropper__btn_exit btn btn-success"></span>' +
                        '<span class="cropper__btn_reset btn btn-danger">Отмена</span>' +
                        '<span class="cropper__btn_cut btn btn-primary">Обрезать</span>' +
                        '<i class="cropper__icon_success glyphicon glyphicon-ok black"></i>' +
                        '<img class="cropper__image" src=' +
                        imageToCropSrc +
                        ' alt="">' +
                        '</div>'
                );

                $(document).ready(function() {
                    $('.cropper__modal-window').css({
                        width: croperWidth + 'px',
                        height: croperHeight + 'px',
                    });
                });

                var image = $('.cropper__image');

                image.croppie({
                    viewport: {
                        width: viewPortWidth,
                        height: viewPortHeight,
                    },
                    boundary: {},
                });
            }
        }

        $(document).on('click', '.cropper__btn_cut', cropperCutHandler);

        function cropperCutHandler(e) {
            $('.cropper__icon_success').fadeIn('slow');
            setTimeout(function() {
                $('.cropper__icon_success').fadeOut('slow');
            }, 1500);

            $('.cropper__image')
                .croppie('result', {
                    type: 'base64',
                    size: 'original',
                    format: imageToCropType,
                })
                .then(function(canvas) {
                    imageToCrop.attr('src', canvas);
                });

            /**
             * @desc сохраняет изображение в необходимую переменную при модификации
             * @author rasul.sahibjanli@gmail.com
             */
            $(imageBlock).on('load', function() {
                $(uploadField).val($(this).attr('src'));
            });
            cropperCutSuccess = true;
        }

        $(document).on('click', '.cropper__btn_exit', function() {
            $('.cropper__modal-window').remove();
        });

        $(document).on('click', '.cropper__btn_reset', function() {
            imageToCrop.attr('src', imageToCropSrc);
            $('.cropper__modal-window').remove();
        });
    }
};

window.imageUploader = imageUploader;

$(function() {
    init_datepickers();
    // init_formsets();

    $('.u-photos-formset').on('click', '.u-delete-photo', function(e) {
        $(this).html('<i class="glyphicon glyphicon-remove white"></i> Удалено');
        $(this)
            .next('input')
            .val('1');
        e.preventDefault();
    });

    $lib.getAllReadyDfr().done(function() {
        var firstAlert = $('.alert-block:last');
        if (firstAlert.length === 1) {
            firstAlert.get(0).scrollIntoView(true);
        }
    });

    /**
     * runs backend function via ajax
     */
    $('.btn_send-users_js').on('click', function(e) {
        e.preventDefault();

        var jqxhr = $.get('/cabinet/persons/generate_petergen_file/', function() {})
            .done(function() {
                var dialog = $('<p>Отправка прошла успешно</p>.').dialog({
                    dialogClass: 'no-close',
                    closeText: null,
                    width: 400,
                    buttons: [
                        {
                            text: 'OK',
                            click: function() {
                                $(this).dialog('close');
                            },
                        },
                    ],
                });
            })
            .fail(function() {
                var dialog = $('<p>При отправке произошла ошибка</p>.').dialog({
                    dialogClass: 'no-close',
                    closeText: null,
                    width: 400,
                    buttons: [
                        {
                            text: 'OK',
                            click: function() {
                                $(this).dialog('close');
                            },
                        },
                    ],
                });
            })
            .always(function() {});
    });
});

/**
 * @title-start ShowPreview
 * @desc создает класс для предпросмотра необходимого контента перед сохранением
 * @desc domelem={
 *      cabinetelem: webelem
 * }
 * @author rasul.sahibjanli@gmail.com
 */

$(function() {
    var modalTemplate =
        '<!-- Modal --> \
    <div id="myModal" class="modal fade" role="dialog">\
      <div class="modal-dialog modal-dialog_show-preview ">\
        <!-- Modal content-->\
        <div class="modal-content">\
          <div class="modal-header">\
            <button type="button" class="close" data-dismiss="modal">&times;</button>\
            <h4 class="modal-title">Режим предпросмотра\
            </h4>\
          </div>\
          <div class="modal-body">\
             <div class="holder">\
                  <div class="preloader">\
                    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>\
                </div>\
             <iframe class="preview-iframe">\
                Ваш браузер не поддерживает плавающие фреймы!\
             </iframe>\
          </div>\
          <div class="modal-footer">\
            <button type="button" id="modal-preview-btn-return" class="btn btn-default btn-lg" data-dismiss="modal">Вернуться к редактированию</button>\
            <button type="button" id="modal-preview-btn-save" class="btn btn-success btn-lg">Сохранить</button>\
          </div>\
        </div>\
      </div>\
    </div>';

    /**
     *
     * @param url
     * @param webRootElem
     * @constructor
     */

    function ShowPreview(url, webRootElem) {
        this.hostName = window.location.origin;
        this.url = url;
        this.webRootElem = webRootElem;

        this._hidePreloader = function() {
            $('.holder').hide();
        };

        this._modifyContent = function(callback) {
            var parentItem = $('.preview-iframe')
                .contents()
                .find(this.webRootElem)[0];

            for (var item in this.elems) {
                if ($(item).is('img')) {
                    var value = $(item).attr('src');
                    if (value !== undefined || value !== '') {
                        $(parentItem)
                            .find(this.elems[item])
                            .attr('src', value);
                    }
                    $(parentItem)
                        .find(this.elems[item])
                        .attr('src', '/static/web/v2/imgs/pub-header.jpg');
                } else {
                    var value = $(item).val();
                    $(parentItem)
                        .find(this.elems[item])
                        .html(value);
                }
            }

            callback;
        }.bind(this);

        this.addModalFrame = function() {
            if (!$('.modal-frame-wrapper').length) {
                $('body').append(modalTemplate);
                $('.preview-iframe').attr('src', this.hostName + this.url);

                $('.preview-iframe').load(
                    function() {
                        console.log('previewIsLoaded');
                        this._modifyContent(this._hidePreloader());

                        $('#modal-preview-btn-save').show();
                        $('#modal-preview-btn-save').on('click', function() {
                            $('#modal-preview-btn-return').trigger('click');
                            $('button[name="save"]').trigger('click');
                        });
                    }.bind(this)
                );
            }
        }.bind(this);
    }

    //@desc Унаследованный класс для предпросмотра публикаций

    function PublicationPreview(
        url,
        webRootElem,
        image,
        title,
        description,
        author,
        date,
        content
    ) {
        ShowPreview.apply(this, [url, webRootElem]);
        this.elems = {
            '#ip-image-block': image,
            '.form-control[data-bind="value: obj.title, valueUpdate: \'input\'"]': title,
            '.form-control[data-bind="value: obj.description, valueUpdate: \'input\'"]': description,
            '.form-control[data-bind="value: obj.author, valueUpdate: \'input\'"]': author,
            '.form-control[data-bind="value: obj.date, valueUpdate: \'input\'"]': date,
            '.tinymce_publications': content,
        };
    }

    //@desc экземпляр для списка публикаций

    var PublicationListPreview = new PublicationPreview(
        '/publications/',
        '.publications__item',
        'img',
        'h3',
        '.publications__description',
        '.publications__author',
        '.publications__date',
        ''
    );

    //@desc экземпляр публикации для главной

    var PublicationMainPreview = new PublicationPreview(
        '',
        '.slider-publications .slider__item',
        'img',
        '.slider__heading_title',
        '.slider__text',
        '.slider__heading_author',
        '.slider__heading_date',
        ''
    );

    //@desc экземпляр публикации для главной новомученников

    var PublicationMartyrsMainPreview = new PublicationPreview(
        '/martyrs/',
        '.slider-publications_priests .slider__item',
        'img',
        '.slider__name_title',
        '.slider__text',
        '.slider__name_author',
        '.slider__name_date',
        ''
    );

    //@desc экземпляр публикации для биографий новомученников

    var PublicationMartyrsBioPreview = new PublicationPreview(
        '/martyrs/biographies/',
        '.sidebar-publications .sidebar-publications__link',
        ' ',
        '.sidebar-publications__title',
        '.sidebar-publications__text',
        '.sidebar-publications__author',
        ' ',
        ''
    );

    //@desc экземпляр публикации для биографий новомученников

    var PublicationSolovki = new PublicationPreview(
        '/solovki/',
        '.sidebar-publications .sidebar-publications__link',
        ' ',
        '.sidebar-publications__title',
        '.sidebar-publications__text',
        '.sidebar-publications__author',
        ' ',
        ''
    );

    //@desc экземпляр публикации для брянской епархии

    var PublicationBryansk = new PublicationPreview(
        '/bryanskaya-eparhia/',
        '.sidebar-publications .sidebar-publications__link',
        ' ',
        '.sidebar-publications__title',
        '.sidebar-publications__text',
        '.sidebar-publications__author',
        ' ',
        ''
    );

    //@desc экземпляр для одной публикации

    var PublicationPublicationPreview = new PublicationPreview(
        '/publication/4/',
        '#publication',
        '#publication-header',
        '#publication-title',
        '#publication-desc',
        '#publication-author',
        '#publication-date',
        '#publication-content-body'
    );

    PublicationPublicationPreview.elems = {
        '#image-block': '#publication-header',
        '.form-control[data-bind="value: obj.title, valueUpdate: \'input\'"]':
            '#publication-title',
        '.form-control[data-bind="value: obj.description, valueUpdate: \'input\'"]':
            '#publication-desc',
        '.form-control[data-bind="value: obj.author, valueUpdate: \'input\'"]':
            '#publication-author',
        '.form-control[data-bind="value: obj.date, valueUpdate: \'input\'"]': '#publication-date',
        '.tinymce_publications': '#publication-content-body',
    };

    PublicationPublicationPreview._modifyContent = function() {
        var parentItem = $('.preview-iframe')
            .contents()
            .find(this.webRootElem)[0];

        for (var item in this.elems) {
            if ($(item).is('img')) {
                var value = $(item).attr('src');
                if (value !== '') {
                    $(parentItem)
                        .find(this.elems[item])
                        .css(
                            'background-image',
                            "url('" + value.replace(/(\r\n|\n|\r)/gm, '') + "')"
                        );
                } else {
                    $(parentItem)
                        .find(this.elems[item])
                        .css(
                            'background-image',
                            "url('" + this.hostName + "/static/web/v2/imgs/pub-header.jpg')"
                        );
                }
            } else if (item === '.tinymce_publications') {
                var value = $('.mce-tinymce iframe')
                    .contents()
                    .find('.tinymce_publications')
                    .html();
                $(parentItem)
                    .find(this.elems[item])
                    .html(value);
            } else {
                var value = $(item).val();
                $(parentItem)
                    .find(this.elems[item])
                    .html(value);
            }
        }

        if ($(parentItem).find('.mce-object.mce-object-video').length) {
            _addVideoToPreview();
        }

        function _addVideoToPreview() {
            var videoSource = $(parentItem)
                .find('.mce-object.mce-object-video')
                .attr('data-mce-html');
            var htmlFontSize = parseInt($('html').css('font-size'), 10);
            var maxHtmlFontSize = 15;
            var width =
                ($(parentItem)
                    .find('.mce-object.mce-object-video')
                    .attr('width') *
                    htmlFontSize) /
                maxHtmlFontSize;
            var height =
                ($(parentItem)
                    .find('.mce-object.mce-object-video')
                    .attr('height') *
                    htmlFontSize) /
                maxHtmlFontSize;
            videoSource = decodeURI(videoSource);
            videoSource = decodeURIComponent(videoSource);
            $(parentItem)
                .find('.mce-object.mce-object-video')
                .replaceWith(
                    '<video controls="controls" width="' +
                        width +
                        '" height="' +
                        height +
                        '">' +
                        videoSource +
                        '</video>'
                );
        }
    };

    var StoryPreview = new PublicationPreview(
        '/story/1/',
        '#story',
        '',
        '#story-title',
        '',
        '',
        '',
        '#story-content'
    );
    StoryPreview._modifyContent = PublicationPublicationPreview._modifyContent;

    var StoryChosenPreview = new PublicationPreview(
        '/',
        '.stories-slider',
        '.story__photo',
        '.story__title',
        '',
        '',
        '',
        '.story__content'
    );
    StoryChosenPreview._modifyContent = PublicationPublicationPreview._modifyContent;

    //@desc отображение цитаты на главной
    var CitationPreview = new PublicationPreview('', '.block-day-quote');

    CitationPreview.elems = {
        'textarea[data-bind="value: obj.citationText"]': '.block__text',
        'input[data-bind="value: obj.personString, valueUpdate: \'input\'"]': '.block__text_italic',
    };

    CitationPreview._modifyContent = function(callback) {
        var parentItem = $('.preview-iframe')
            .contents()
            .find(this.webRootElem)[0];

        for (var item in this.elems) {
            var value = $(item).val();
            // console.log(value);
            if (
                $('input[data-bind="value: obj.personId, valueUpdate: \'input\'"]').val() !== '' &&
                item === 'input[data-bind="value: obj.personString, valueUpdate: \'input\'"]'
            ) {
                var link =
                    '<a href="/person/5799/" class="block__button block__button_type_string"><span>' +
                    value +
                    '</span></a>';
                $(parentItem)
                    .find(this.elems[item])
                    .html(link);
            } else {
                $(parentItem)
                    .find(this.elems[item])
                    .html(value);
            }
        }

        callback;
    };

    //@desc отображение материала на главной
    var MainMaterial = new PublicationPreview('', '.favorites-materials');

    MainMaterial.elems = {
        'input[data-bind="value: obj.materialTitle, valueUpdate: \'input\'"]':
            '.favorites-materials__title',
        'input[data-bind="value: obj.materialAuthor, valueUpdate: \'input\'"]':
            '.favorites-materials__text',
    };

    MainMaterial._modifyContent = function(callback) {
        var parentItem = $('.preview-iframe')
            .contents()
            .find(this.webRootElem)[0];

        for (var item in this.elems) {
            if (item === 'input[data-bind="value: obj.materialAuthor, valueUpdate: \'input\'"]') {
                if ($(item).val() !== '') {
                    $(parentItem)
                        .find('.favorites-materials__title')
                        .removeClass('favorites-materials__title_long');
                } else {
                    $(parentItem)
                        .find('.favorites-materials__title')
                        .addClass('favorites-materials__title_long');
                }
            }
            var value = $(item).val();
            $(parentItem)
                .find(this.elems[item])
                .html(value);
        }

        callback;
    };

    //@desc отображение избранной фотографии на главной
    var MainImage = new PublicationPreview('', '.block-profile-js');

    MainImage.elems = {
        '.main-image-preview': '.slider__item__link img',
        'input[data-bind="value: obj.personString, valueUpdate: \'input\'"]':
            '.block-profile__info a', // name + date
        'input[data-bind="value: obj.personDates, valueUpdate: \'input\'"]':
            '.block-profile__info a', // name + date
        'textarea[data-bind="value: obj.personServingPlaces"]': '.block__text', //places
    };

    MainImage._modifyContent = function(callback) {
        var parentItem = $('.preview-iframe')
            .contents()
            .find(this.webRootElem)[0];

        var monkInfo = '';
        var value = '';

        for (var item in this.elems) {
            if (this.elems[item] === '.block-profile__info a') {
                monkInfo = monkInfo + $(item).val() + ' ';
                $(parentItem)
                    .find(this.elems[item])
                    .html(monkInfo.trim());
            } else if ($(item).is('img')) {
                value = $(item).attr('src');
                if (value !== undefined && value !== '') {
                    $(parentItem)
                        .find(this.elems[item])
                        .attr('src', value);
                }
            } else {
                value = $(item).val();
                $(parentItem)
                    .find(this.elems[item])
                    .html(value);
            }
        }

        callback;
    };

    $('.btn-show-preview').on('click', function() {
        $('.holder').show();
        if ($('.select-publication-type').length) {
            switch ($('.select-publication-type').val()) {
                case 'main':
                    PublicationMainPreview.addModalFrame();
                    break;
                case 'publication':
                case 'martyr_pub':
                    PublicationListPreview.addModalFrame();
                    break;
                case 'martyr_main':
                    PublicationMartyrsMainPreview.addModalFrame();
                    break;
                case 'martyr_per':
                    PublicationMartyrsBioPreview.addModalFrame();
                    break;
                case 'solovki_main':
                    PublicationSolovki.addModalFrame();
                    break;
                case 'bryansk_main':
                    PublicationBryansk.addModalFrame();
                    break;
            }
        } /*else {
            if($('.edit-citation')) {
                CitationPreview.addModalFrame();
            } else {
                PublicationPublicationPreview.addModalFrame();
            }
        }*/ else if (
            $('.preview-title-js').length
        ) {
            switch ($('.preview-title-js').data('title')) {
                case 'Избранная цитата':
                    CitationPreview.addModalFrame();
                    break;
                case 'Избранный материал':
                    MainMaterial.addModalFrame();
                    break;
                case 'Публикация':
                    PublicationPublicationPreview.addModalFrame();
                    break;
                case 'Избранная фотография':
                    MainImage.addModalFrame();
                    break;
                case 'История дня':
                    StoryPreview.addModalFrame();
                    break;
                case 'Избранная история дня':
                    StoryChosenPreview.addModalFrame();
                    break;
            }
        } /*else {
            PublicationPublicationPreview.addModalFrame();
        }*/
        /*sfas*/
    });
});

// show modal instead of new person
$(function() {
    $('.replace-url-js').on('click', function(e) {
        e.preventDefault();

        var shouldDelete = confirm('Вы уверены, что хотите удалить материал?');

        var urlParams = getUrlParams() === '' ? '' : '?' + getUrlParams();

        if (shouldDelete) {
            var newUrl = $(this).attr('href') + urlParams;
            window.location = newUrl;
        }
    });

    function replaceUrl(oldUrl, newUrl) {}

    function getUrlParams() {
        var params = '';
        if (window.location.href.indexOf('?') > -1) {
            params = decodeURIComponent(
                window.location.href.slice(window.location.href.indexOf('?') + 1)
            );
        }

        return params;
    }

    function getCurrentPageNumber() {
        return $('.pagination .active a').html();
    }

    /**
     * Смена фона в кабинете для раздела "Справочники"
     */
    if (document.URL.match('/references/') && document.URL.match('global_filter=1')) {
        $('body').css({
            background: '#c8c2b5',
        });
    }

    var modalContent =
        '<div><p><b>Создать персону в основной базе или персону мирянин/женское монашество для тематической базы?</b></p>' +
        '<p><a href="/cabinet/persons/create/?is_primary=true" class="new-person__link">В основной базе </a></p>' +
        '<p><a href="/cabinet/persons/create/?is_primary=false" class="new-person__link">Мирянин/женское монашество для тематической базы</a></p>' +
        '</div>';

    $('.new-person-button').removeAttr('href');

    $('.new-person-button').on('click', function(e) {
        e.preventDefault();
        $(modalContent).dialog({
            dialogClass: 'no-close',
            closeText: null,
            modal: true,
            minWidth: 590,
            open: function(event, ui) {
                $(this)
                    .find('input')
                    .val(typeheadInputValue);
            },
            buttons: [
                {
                    text: 'Закрыть',
                    click: function() {
                        $(this).dialog('close');
                    },
                },
            ],
        });
    });

    $('.fancybox').fancybox();

    Person();
    EditorPanel();
    Task();
    Records();
    Reference();
    Material();
    Profile();
});

$(window).load(function () {
    $('.js-select2-single').select2({
            selectionCssClass: "select2-custom",
            minimumResultsForSearch: Infinity,
            width: '100%',
    });

    // https://redmine.pravoslavnoe-duhovenstvo.ru/issues/1549
    // Вешаем на кнопку сохранения проверку откадрирована ли фотка в историях (cropperCutSuccess)

    function errorModal() {
        var modalContent ='<div><p><b>Пожалуйста, обрежьте изображение перед сохранением</b></p></div>';
        $(modalContent).dialog({
            dialogClass: 'no-close',
            closeText: null,
            modal: true,
            minWidth: 590,
            open: function(event, ui) {
                $(this)
                    .find('input')
                    .val(typeheadInputValue);
            },
            buttons: [
                {
                    text: 'Закрыть',
                    click: function() {
                        $(this).dialog('close');
                    },
                },
            ],
        });
    }

    var save_and_continue = document.querySelector('button[name="save"]');
    if (save_and_continue) {
        let save_and_continue_bak = ko.dataFor(save_and_continue).save;
        ko.dataFor(save_and_continue).save = function() {
            if(cropperCutSuccess){
                save_and_continue_bak();
            }else{
                errorModal();
            }
        };
    }

    var save_and_exit = document.querySelector('button[name="save-and-exit"]');
    if (save_and_exit) {
        let save_and_exit_bak = ko.dataFor(save_and_exit).saveAndExit;
        ko.dataFor(save_and_exit).saveAndExit = function() {
            if(cropperCutSuccess){
                save_and_exit_bak();
            }else{
                errorModal();
            }
        };
    }

    var save_and_new = document.querySelector('button[name="save-and-new"]');
    if (save_and_new) {
        let save_and_new_bak = ko.dataFor(save_and_new).saveAndNew;
        ko.dataFor(save_and_new).saveAndNew = function() {
            if(cropperCutSuccess){
                save_and_new_bak();
            }else{
                errorModal();
            }
        };
    }


});
